const SET_LOADER = "SET_LOADER";

const state = {
  loader: false
};

const actions = {
  startLoader({ commit }) {
    commit("SET_LOADER", true);
  },
  stopLoader({ commit }) {
    commit("SET_LOADER", false);
  }
};

const mutations = {
  [SET_LOADER](state, loader) {
    state.loader = loader;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/creators/loader.js